"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var file_vue_1 = require("./file.vue");
exports.default = file_vue_1.default;
